import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Label
} from 'reactstrap';
import {
  WHO_REFERENCE_LINE,
  EPA_REFERENCE_LINE,
  CUSTOM_REFERENCE_LINE,
  NONE_REFERENCE_LINE
} from '../../../constants/reportLayouts';
import InfoInputField from '../../shared/LabeledTextInput';
import Card from '../../shared/Card';
import { UNITS, METRIC, IMPERIAL } from '../../../constants/uom';
import { formatRadon } from '../../../utils/formatters'


class ChartReferenceLine extends React.Component {

  static get propTypes() {
    return {
      value: PropTypes.string,
      customLabel: PropTypes.string,
      customLevel: PropTypes.string,
      onChangeReferenceLine: PropTypes.func,
      onChangeCustomLabel: PropTypes.func,
      onChangeCustomLevel: PropTypes.func
    }
  }

  render() {
    const {
      value,
      customLabel,
      customLevel,
      onChangeReferenceLine,
      onChangeCustomLabel,
      onChangeCustomLevel
    } = this.props;
    const epaLevel = `(${formatRadon(4, IMPERIAL)} ${UNITS.radon.pciL}, ${formatRadon(148, METRIC)} ${UNITS.radon.bqM3})`;
    const whoLevel = `(${formatRadon(2.7, IMPERIAL)} ${UNITS.radon.pciL}, ${formatRadon(99.9, METRIC)} ${UNITS.radon.bqM3})`;

    return (
      <Card header='Chart Reference Line'>
        <Row>
          <Col lg={6}>
            <Row className='mb-3'>
              <Col>
                <Label check>
                  <input
                    className='mr-2'
                    type='radio'
                    value={EPA_REFERENCE_LINE}
                    name='refenceLine'
                    checked={value === EPA_REFERENCE_LINE}
                    onClick={onChangeReferenceLine}
                  />
                  EPA Action Level {epaLevel}
                </Label>
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col>
                <Label check>
                  <input
                    className='mr-2'
                    type='radio'
                    value={WHO_REFERENCE_LINE}
                    name='refenceLine'
                    checked={value === WHO_REFERENCE_LINE}
                    onClick={onChangeReferenceLine}
                  />
                  WHO Action Level {whoLevel}
                </Label>
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col>
                <Label check>
                  <input
                    className='mr-2'
                    type='radio'
                    value={CUSTOM_REFERENCE_LINE}
                    name='referenceLine'
                    checked={value === CUSTOM_REFERENCE_LINE}
                    onClick={onChangeReferenceLine}
                  />
                  Custom Reference Line
                </Label>
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col>
                <Label check>
                  <input
                    className='mr-2'
                    type='radio'
                    value={NONE_REFERENCE_LINE}
                    name='referenceLine'
                    checked={!value || (value === NONE_REFERENCE_LINE)}
                    onClick={onChangeReferenceLine}
                  />
                  None
                </Label>
              </Col>
            </Row>
          </Col>
          <Col lg={6}>
            <Row className='mb-3'>
              <Col>
                <InfoInputField
                  editMode={true}
                  label='Custom Line Label'
                  value={customLabel}
                  onChange={onChangeCustomLabel}
                  disabled={value !== CUSTOM_REFERENCE_LINE}
                />
              </Col>
            </Row>  
            <Row className='mb-3'>
              <Col>
                <InfoInputField
                  type='number'
                  editMode={true}
                  label='Custom Line Value'
                  value={customLevel}
                  onChange={onChangeCustomLevel}
                  disabled={value !== CUSTOM_REFERENCE_LINE}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default ChartReferenceLine;


// WEBPACK FOOTER //
// src/components/reportManagement/ChartReferenceLine/index.jsx